import React, { useState } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  const navigate = useNavigate();
  const location = useLocation();

  const {
    restaurantId,
    tableId,
  } = useParams();

  const {
    cartCount,
  } = useCart();

  const [menuOpen, setMenuOpen] = useState(false);


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  /* =========================================================
     CLOSE MOBILE MENU
  ========================================================= */

  const closeMobileMenu = () => {
    setMenuOpen(false);
  };


  /* =========================================================
     SECTION NAVIGATION
  ========================================================= */

  const goToSection = (sectionClass) => {

    closeMobileMenu();

    if (location.pathname === homePath) {

      const element =
        document.querySelector(`.${sectionClass}`);

      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;
    }


    navigate(homePath);


    setTimeout(() => {

      const element =
        document.querySelector(`.${sectionClass}`);

      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

    }, 500);
  };


  /* =========================================================
     HOME
  ========================================================= */

  const handleHome = () => {

    closeMobileMenu();

    if (location.pathname === homePath) {

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;
    }

    navigate(homePath);
  };


  /* =========================================================
     MENU
  ========================================================= */

  const handleMenu = () => {

    goToSection("t6-menu-section");

  };


  /* =========================================================
     STORY
  ========================================================= */

  const handleStory = () => {

    goToSection("t6-story");

  };


  /* =========================================================
     GALLERY
  ========================================================= */

  const handleGallery = () => {

    goToSection("t6-gallery");

  };


  /* =========================================================
     CART
  ========================================================= */

  const handleCart = () => {

    closeMobileMenu();

    navigate(`${homePath}/cart`);

  };


  /* =========================================================
     HAMBURGER
  ========================================================= */

  const toggleMobileMenu = () => {

    setMenuOpen((previous) => !previous);

  };


  return (

    <header className="t6-header">

      <div className="t6-header-inner">


        {/* =================================================
            LOGO
        ================================================= */}

        <button
          type="button"
          className="t6-logo"
          onClick={handleHome}
        >

          <span className="t6-logo-main">
            KAVOS
          </span>

          <span className="t6-logo-sub">
            TAVERNA
          </span>

        </button>


        {/* =================================================
            DESKTOP NAVIGATION
        ================================================= */}

        <nav className="t6-navigation">

          <button
            type="button"
            onClick={handleHome}
          >
            Home
          </button>

          <button
            type="button"
            onClick={handleMenu}
          >
            Menu
          </button>

          <button
            type="button"
            onClick={handleStory}
          >
            Our Story
          </button>

          <button
            type="button"
            onClick={handleGallery}
          >
            Gallery
          </button>

        </nav>


        {/* =================================================
            HEADER ACTIONS
        ================================================= */}

        <div className="t6-header-actions">


          {/* TABLE */}

          <div className="t6-table-number">

            <span>
              TABLE
            </span>

            <strong>
              {tableId}
            </strong>

          </div>


          {/* CART */}

          <button
            type="button"
            className="t6-cart-button"
            onClick={handleCart}
          >

            <span className="t6-cart-icon">
              🛒
            </span>

            <span className="t6-cart-text">
              CART
            </span>

            {cartCount > 0 && (

              <span className="t6-cart-count">
                {cartCount}
              </span>

            )}

          </button>


          {/* =================================================
              MOBILE HAMBURGER
          ================================================= */}

          <button
            type="button"
            className={`t6-hamburger ${
              menuOpen ? "active" : ""
            }`}
            onClick={toggleMobileMenu}
            aria-label="Open menu"
            aria-expanded={menuOpen}
          >

            <span></span>
            <span></span>
            <span></span>

          </button>

        </div>

      </div>


      {/* =====================================================
          MOBILE MENU
      ===================================================== */}

      <div
        className={`t6-mobile-menu ${
          menuOpen ? "open" : ""
        }`}
      >

        <button
          type="button"
          onClick={handleHome}
        >
          Home
        </button>

        <button
          type="button"
          onClick={handleMenu}
        >
          Menu
        </button>

        <button
          type="button"
          onClick={handleStory}
        >
          Our Story
        </button>

        <button
          type="button"
          onClick={handleGallery}
        >
          Gallery
        </button>

      </div>

    </header>

  );
}


export default Header;